// Telnyx connection + provider-neutral voice lines (plan B1). Connecting uses createTokenConnection (provider
// "telnyx"); revalidation uses checkConnection; project mapping uses updateEndpoint.
import { z } from 'zod';
import * as T from './api-telnyx.js';
import { IdParam, route, W, Ws } from './route-def.js';

export const telnyxRoutes = {
  getTelnyxSetup: route({
    method: 'GET', path: '/workspaces/:workspaceId/telnyx/setup', summary: 'Telnyx: capacidades, webhook firmado y líneas de voz', tag: 'telnyx',
    minRole: 'manager', params: Ws, response: T.TelnyxSetupSchema,
  }),
  syncTelnyxNumbers: route({
    method: 'POST', path: '/workspaces/:workspaceId/telnyx/connections/:connectionId/sync-numbers', summary: 'Sincronizar los números de la cuenta de Telnyx como líneas', tag: 'telnyx',
    minRole: 'admin', params: W({ connectionId: IdParam }), response: T.TelnyxConnectionSetupSchema,
  }),
  setTelnyxWebhookKey: route({
    method: 'PUT', path: '/workspaces/:workspaceId/telnyx/connections/:connectionId/webhook-key', summary: 'Guardar la llave pública (Ed25519) con la que Telnyx firma los webhooks', tag: 'telnyx',
    minRole: 'admin', params: W({ connectionId: IdParam }), body: T.SetTelnyxWebhookKeySchema, response: T.TelnyxConnectionSetupSchema,
  }),
  updateTelnyxLine: route({
    method: 'PATCH', path: '/workspaces/:workspaceId/telnyx/lines/:endpointId', summary: 'Activar/desactivar una línea de Telnyx y su política de entrantes', tag: 'telnyx',
    minRole: 'admin', params: W({ endpointId: IdParam }), body: T.UpdateTelnyxLineSchema, response: T.TelnyxLineSchema,
  }),
  telnyxWebhook: route({
    method: 'POST', path: '/providers/telnyx/:connectionId/webhooks', summary: 'Webhook de Telnyx (firma Ed25519 verificada; se guarda sin procesar)', tag: 'ingress',
    public: 'ingress', params: z.object({ connectionId: IdParam }), response: T.TelnyxWebhookAckSchema,
  }),
} as const;
